import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../EmptyFragment';
import { AlreadyTranslated, T } from '../../../../../../../Translations';
import { ProductLicenseResource } from '../../../../../Types';

interface Props {
  productLicense: ProductLicenseResource;
}

function Title({ productLicense }: Props) {
  return productLicense.payload.licenseTypePublicName
    .map((licenseTypePublicName) => {
      const title = <AlreadyTranslated content={licenseTypePublicName} />;
      return (
        <T
          kind="Your <licenseTitle/> license allows access to the following program types:"
          licenseTitle={title}
        />
      );
    })
    .getOrElse(emptyFragment);
}

export default observer(Title);
